<template>
  <div
    class="home-page d-flex align-items-center justify-content-center text-center"
    style="background-image: url('/images/unais.png');"
  >
    <!-- Dark Gradient Overlay -->
    <div class="overlay"></div>

    <!-- Content -->
    <div class="content text-white">
      <h1 class="mb-3 display-4 fw-bold animate__animated animate__fadeInDown">
        Unais Vattamannil
      </h1>
      <p class="lead mb-4 animate__animated animate__fadeInUp">
        PHP Laravel Developer | Full Stack Enthusiast
      </p>
      <router-link
        to="/about"
        class="btn btn-primary btn-lg me-2 shadow-sm animate__animated animate__fadeInUp"
        style="animation-delay: 0.3s"
      >
        <i class="bi bi-person-fill me-2"></i> About Me
      </router-link>
      <router-link
        to="/contact"
        class="btn btn-outline-light btn-lg shadow-sm animate__animated animate__fadeInUp"
        style="animation-delay: 0.5s"
      >
        <i class="bi bi-envelope-fill me-2"></i> Contact
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage"
};
</script>

<style scoped>
.home-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: "Poppins", sans-serif;
}

/* Gradient Overlay */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
 background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0.45) 40%,
    rgba(0, 0, 0, 0.25) 100%
  );
    z-index: 1;
}

/* Content above overlay */
.content {
  position: relative;
  z-index: 2;
  max-width: 700px;
  padding: 20px;
}
</style>
